import { IPG } from "@/types/summary";
import SpeakItem, { EditItem } from "@/component/SpeakItem";
import RecordHelper from "@/bussiness/RecordHelper";
import fridayReporter from "@/utils/friday";
import { IBlurParaInfo } from "@/types/record";
interface IListItemProps {
  record: IPG;
  isGenerating?: boolean;
  unstableText?: string;
  unstableTime?: number;
  placeholder?: string;
  setItemSize?: (pHeight: number) => void;
}

export default function ListItem(props: IListItemProps) {
  const {
    record,
    isGenerating = false,
    unstableText,
    unstableTime,
    placeholder,
  } = props;

  const handleEdit = (
    pi: string,
    editItems: EditItem[],
    emptyWordAllowed = false
  ) => {
    // console.log("handleEdit", editItems, emptyWordAllowed);
    RecordHelper.editRecord(pi, editItems, {
      isLastRecord: isGenerating,
      emptyWordAllowed,
    });
  };

  const handleMerge = (pi: string) => {
    console.log("handleMerge", pi);
    RecordHelper.mergeRecord(pi, isGenerating);
  };

  const handleSplit = (editItem: EditItem, cIndex: number, pi: string) => {
    console.log("handleSplit", editItem, cIndex, pi);
    RecordHelper.splitRecord(pi, editItem.wi, cIndex, isGenerating);
  };

  const handleMark = (pi: string, signFlag: boolean) => {
    console.log("handleMark", pi, signFlag);
    fridayReporter.pushData({
      eventCode: signFlag ? "RecordPage_Edit_Mark" : "RecordPage_Edit_Unmark",
    });
    RecordHelper.signRecord(pi, signFlag, isGenerating);
  };

  const handleEditSpeaker = (pi: string, newSpeakName: string[]) => {
    console.log("handleEditSpeaker", pi, newSpeakName);
    RecordHelper.modifySpeakerName(pi, newSpeakName, isGenerating);
  };

  const handleBlur = (para: IBlurParaInfo)=>{
    RecordHelper.correctRecordOnBlur(para);
  }

  return (
    <SpeakItem
      record={record}
      isEditing
      isGenerating={isGenerating}
      unstableText={unstableText}
      unstableTime={unstableTime}
      placeholder={placeholder}
      handleEdit={handleEdit}
      handleEnter={handleSplit}
      handleMerge={handleMerge}
      handleMark={handleMark}
      handleEditSpeaker={handleEditSpeaker}
      onBlur={handleBlur}
    />
  );
}
